export { CollapseDirective } from './collapse.directive';
export { CollapseModule } from './collapse.module';



// WEBPACK FOOTER //
// ./.tmp/collapse/index.ts